import { cloneDeep } from '@studio/utils/clone';
import { deepEqual, omit } from '@studio/utils/utils';
import { copySpan, copyStyle, hasSamePreviousStyleIds, hasSameStyleIds, hasSameStyleProperty, isWordSpan } from './utils';
export function createWordSpanFromCharacter(char, style, attributes = {}, ids = {}) {
    return {
        type: "word" /* SpanType.Word */,
        content: String.fromCharCode(char),
        style: copyStyle(style),
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        lineHeight: 0,
        attributes: cloneDeep(attributes),
        styleIds: ids.styleIds || {},
        styleId: ids.styleId,
        __previousStyleIds: [...(ids.previousStyleIds || [])],
        __previousStyleIdToHistoryIndexMap: new Map(ids.previousStyleIdToHistoryIndexMap || [])
    };
}
export function isSpanMergeable_m(source, target) {
    if (source.type === "newline" /* SpanType.Newline */ || source.type === "end" /* SpanType.End */) {
        return false;
    }
    if (source.type !== target.type) {
        return false;
    }
    if (!hasSameStyleIds(source.styleIds, target.styleIds)) {
        return false;
    }
    if (!hasSamePreviousStyleIds(source.__previousStyleIds, target.__previousStyleIds)) {
        return false;
    }
    return hasSpanSameStyleAndAttributes_m(source, target);
}
export function hasSpanSameStyleAndAttributes_m(source, target) {
    const sourceStyle = omit(source.style, '__fontFamilyId');
    const targetStyle = omit(target.style, '__fontFamilyId');
    if (Object.keys(sourceStyle).length !== Object.keys(targetStyle).length) {
        return false;
    }
    for (const property in sourceStyle) {
        if (!hasSameStyleProperty(property, sourceStyle, targetStyle)) {
            return false;
        }
    }
    const sourceAttributes = omit(source.attributes, 'shouldRenderNumber');
    const targetAttributes = omit(target.attributes, 'shouldRenderNumber');
    if (Object.keys(sourceAttributes).length !== Object.keys(targetAttributes).length) {
        return false;
    }
    for (const attribute in sourceAttributes) {
        if (!deepEqual(source.attributes[attribute], target.attributes[attribute])) {
            return false;
        }
    }
    return true;
}
export function explodeSpans(spans) {
    const explodedSpans = [];
    for (const span of spans) {
        // explode word spans into words per character
        if (isWordSpan(span)) {
            const wordSpans = [...span.content].map(char => createWordSpanFromCharacter(char.charCodeAt(0), span.style));
            explodedSpans.push(...wordSpans);
        }
        else {
            explodedSpans.push(copySpan(span));
        }
    }
    return explodedSpans;
}
export function mergeSpans(spans) {
    const mergedSpans = [];
    let lastSpan;
    for (const span of spans) {
        if (!lastSpan) {
            lastSpan = span;
            continue;
        }
        if (isSpanMergeable_m(lastSpan, span)) {
            lastSpan.content += span.content;
        }
        else {
            mergedSpans.push(lastSpan);
            lastSpan = span;
        }
    }
    if (lastSpan) {
        mergedSpans.push(lastSpan);
    }
    return mergedSpans;
}
